import 'mdn-polyfills/MouseEvent'
import 'mdn-polyfills/CustomEvent'
import '@webcomponents/webcomponentsjs/webcomponents-bundle.js'
